// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import { Table, Tr, Th } from 'app/common/ui-components/table';
import PlainTooltip from 'app/common/ui-next/plain-tooltip';
import type { Discipline } from 'app/dataTypes/Discipline.types';

import styles from './TableFixed.scss';


type Props = {
  className?: string,
  disciplines: Array<Discipline>,
  onMouseEnterRow: (e: SyntheticMouseEvent<HTMLElement>) => void,
  onMouseLeaveRow: (e: SyntheticMouseEvent<HTMLElement>) => void,
  loading?: boolean,
}

const TableFixed = ({
  className,
  disciplines,
  onMouseEnterRow,
  onMouseLeaveRow,
  loading,
}: Props): Node => {
  return (
    <Table className={cn(styles.root, className)}>
      <tbody>
        {disciplines.map(({ id, title }, index) => (
          <Tr
            key={id}
            className={cn(styles.row, `hover_h_${index}`)}
            onMouseEnter={onMouseEnterRow}
            onMouseLeave={onMouseLeaveRow}
          >
            <Th className={styles.th} stripPadding>
              {loading
                ? <div className={styles.loading}>&nbsp;</div>
                : <PlainTooltip text={title} className={styles.content} hideWithoutOverflow>
                  {`${index + 1}. ${title}`}
                </PlainTooltip>}
            </Th>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TableFixed;
